// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"a4486638","963":"a4486638"}[chunkId] + ".chunk.css";
};